import * as React from 'react';
import cx from 'classnames';
import { useSpring, animated } from '@react-spring/web';

// eslint-disable-next-line @babel/new-cap
const LogoAnimation = async (next: typeof useSpring) => {
    await next({
        delay: 200,
        opacity: 1,
        transform: 'translate3d(0,0,0)',
        from: { opacity: 0, transform: `translate3d(0,28px, 0)` },
    });
    await next({
        delay: 600,
        opacity: 0,
    });
};

type LogoProps = {
    isAnimated?: boolean;
    isLarge?: boolean;
    isXLarge?: boolean;
    isOld?: boolean;
    isNew?: boolean;
    isWhite?: boolean;
    width?: number | string;
    color?: string;
};

function Logo(props: LogoProps) {
    const { isAnimated, isWhite, isLarge, isXLarge, isOld = true, isNew, width, color } = props;

    if (isOld) {
        return (
            <svg
                className="logotype__image"
                viewBox="0 0 275 48"
                style={{
                    color,
                }}
            >
                <path d="M239.339 41.897c1.5-.261 2.948.668 3.289 2.153l.022.091a2.836 2.836 0 01-1.895 3.337c-1.009.323-2.177.528-3.665.52-5.049-.024-9.104-4.19-9.104-9.241V3.184A3.184 3.184 0 01231.17 0h.002a3.183 3.183 0 013.182 3.184v35.264c0 2.082 1.593 3.551 3.919 3.551.326 0 .686-.036 1.066-.102zm-158.32.47c-5.02 0-9.98-3.979-9.98-10.407 0-6.368 4.96-10.409 9.98-10.409 5.571 0 9.918 4.04 9.918 10.409 0 6.428-4.347 10.407-9.918 10.407zm1.037-26.448c-4.713 0-9.057 2.481-11.02 5.975V3.184a3.184 3.184 0 00-6.369 0v41.633A3.193 3.193 0 0067.852 48a3.193 3.193 0 003.183-3.183l.002-2.791C72.864 45.544 77.343 48 82.057 48c7.957 0 15.059-6.428 15.059-16.04 0-9.552-7.102-16.041-15.06-16.041zM207.57 42.367c-5.021 0-9.979-3.979-9.979-10.407 0-6.368 4.958-10.409 9.979-10.409 5.572 0 9.918 4.04 9.918 10.409 0 6.428-4.346 10.407-9.918 10.407zm1.042-26.448c-4.714 0-9.058 2.481-11.02 5.975l-.001-18.71a3.184 3.184 0 00-6.368 0v41.633A3.194 3.194 0 00194.408 48a3.193 3.193 0 003.183-3.183l.001-2.791c1.828 3.518 6.306 5.974 11.02 5.974 7.958 0 15.059-6.428 15.059-16.04 0-9.552-7.101-16.041-15.059-16.041zm-84.441 4.04a3.183 3.183 0 116.367 0v24.857a3.193 3.193 0 01-3.184 3.183 3.192 3.192 0 01-3.183-3.183v-2.792c-1.597 3.482-6 5.975-10.469 5.975-7.347 0-12.184-5.265-12.184-12.917V19.959a3.184 3.184 0 016.368 0v13.836c0 4.959 2.876 8.328 7.285 8.328 5.449 0 9-3.674 9-11.328V19.958zm49.814-4.041c-5.02 0-9.137 2.112-11.326 6.086-1.684-3.718-5.754-6.086-10.102-6.086-4.347 0-7.982 2.742-9.734 5.961v-1.92a3.184 3.184 0 00-6.367 0v24.857a3.192 3.192 0 003.182 3.183 3.194 3.194 0 003.185-3.184V32.081c0-6.796 3.184-10.286 8.081-10.286 3.919 0 6.858 2.817 6.858 7.286l.03 15.735a3.193 3.193 0 003.183 3.183 3.194 3.194 0 003.185-3.184l-.031-12.734c0-6.796 3.244-10.286 8.204-10.286 3.918 0 6.857 2.817 6.857 7.286l-.063 15.735a3.193 3.193 0 003.184 3.183 3.193 3.193 0 003.184-3.184v-17.02c0-7.163-5.204-11.877-11.51-11.877zm84.968 0c12.115 0 14.563 11.188 15.057 15.71a1.677 1.677 0 01-1.666 1.862h-22.819c.612 5.632 4.713 8.999 9.183 8.999 2.918 0 5.881-.735 8.015-3.72a2.841 2.841 0 012.908-1.118c2.027.435 2.921 2.818 1.689 4.486-2.886 3.908-7.336 5.862-12.612 5.862-8.265 0-15.489-6.367-15.489-15.979 0-9.674 7.162-16.102 15.734-16.102zm.001 5.633c-3.979 0-8.266 2.51-9.245 7.408h17.877c-.979-4.96-4.469-7.408-8.632-7.408zM15.151 27.038H39.16a2.994 2.994 0 100-5.988H15.151a2.994 2.994 0 100 5.988zm8.324 10.342h7.354a2.995 2.995 0 000-5.989h-7.354a2.995 2.995 0 000 5.99zm10.303-26.673H20.527a2.994 2.994 0 100 5.988h13.251a2.994 2.994 0 100-5.988zm8.256-8.962l11.841 20.51a3.49 3.49 0 010 3.488l-11.841 20.51a3.489 3.489 0 01-3.022 1.744H15.331a3.489 3.489 0 01-3.022-1.744L.468 25.743a3.484 3.484 0 010-3.488l11.841-20.51A3.487 3.487 0 0115.331 0h23.681c1.247 0 2.4.665 3.022 1.745z" />
            </svg>
        );
    }

    const className = cx({
        logotype: true,
        'logotype--lg': isLarge,
        'logotype--xlg': isXLarge,
        'logotype--white': isWhite,
        'logotype--inherit': isNew,
    });

    const logoElement = (
        <span className={className}>
            <svg
                className="logotype__image"
                viewBox="0 0 275 48"
                style={{
                    width,
                    height: width ? 'auto' : undefined,
                    minWidth: width ? '120px' : undefined,
                    color,
                }}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M239.339 41.897c1.5-.261 2.948.668 3.289 2.153l.022.091a2.836 2.836 0 01-1.895 3.337c-1.009.323-2.177.528-3.665.52-5.049-.024-9.104-4.19-9.104-9.241V3.184A3.184 3.184 0 01231.17 0h.002a3.183 3.183 0 013.182 3.184v35.264c0 2.082 1.593 3.551 3.919 3.551.326 0 .686-.036 1.066-.102zm-158.32.47c-5.02 0-9.98-3.979-9.98-10.407 0-6.368 4.96-10.409 9.98-10.409 5.571 0 9.918 4.04 9.918 10.409 0 6.428-4.347 10.407-9.918 10.407zm1.037-26.448c-4.713 0-9.057 2.481-11.02 5.975V3.184a3.184 3.184 0 00-6.369 0v41.633A3.193 3.193 0 0067.852 48a3.193 3.193 0 003.183-3.183l.002-2.791C72.864 45.544 77.343 48 82.057 48c7.957 0 15.059-6.428 15.059-16.04 0-9.552-7.102-16.041-15.06-16.041zM207.57 42.367c-5.021 0-9.979-3.979-9.979-10.407 0-6.368 4.958-10.409 9.979-10.409 5.572 0 9.918 4.04 9.918 10.409 0 6.428-4.346 10.407-9.918 10.407zm1.042-26.448c-4.714 0-9.058 2.481-11.02 5.975l-.001-18.71a3.184 3.184 0 00-6.368 0v41.633A3.194 3.194 0 00194.408 48a3.193 3.193 0 003.183-3.183l.001-2.791c1.828 3.518 6.306 5.974 11.02 5.974 7.958 0 15.059-6.428 15.059-16.04 0-9.552-7.101-16.041-15.059-16.041zm-84.441 4.04a3.183 3.183 0 116.367 0v24.857a3.193 3.193 0 01-3.184 3.183 3.192 3.192 0 01-3.183-3.183v-2.792c-1.597 3.482-6 5.975-10.469 5.975-7.347 0-12.184-5.265-12.184-12.917V19.959a3.184 3.184 0 016.368 0v13.836c0 4.959 2.876 8.328 7.285 8.328 5.449 0 9-3.674 9-11.328V19.958zm49.814-4.041c-5.02 0-9.137 2.112-11.326 6.086-1.684-3.718-5.754-6.086-10.102-6.086-4.347 0-7.982 2.742-9.734 5.961v-1.92a3.184 3.184 0 00-6.367 0v24.857a3.192 3.192 0 003.182 3.183 3.194 3.194 0 003.185-3.184V32.081c0-6.796 3.184-10.286 8.081-10.286 3.919 0 6.858 2.817 6.858 7.286l.03 15.735a3.193 3.193 0 003.183 3.183 3.194 3.194 0 003.185-3.184l-.031-12.734c0-6.796 3.244-10.286 8.204-10.286 3.918 0 6.857 2.817 6.857 7.286l-.063 15.735a3.193 3.193 0 003.184 3.183 3.193 3.193 0 003.184-3.184v-17.02c0-7.163-5.204-11.877-11.51-11.877zm84.968 0c12.115 0 14.563 11.188 15.057 15.71a1.677 1.677 0 01-1.666 1.862h-22.819c.612 5.632 4.713 8.999 9.183 8.999 2.918 0 5.881-.735 8.015-3.72a2.841 2.841 0 012.908-1.118c2.027.435 2.921 2.818 1.689 4.486-2.886 3.908-7.336 5.862-12.612 5.862-8.265 0-15.489-6.367-15.489-15.979 0-9.674 7.162-16.102 15.734-16.102zm.001 5.633c-3.979 0-8.266 2.51-9.245 7.408h17.877c-.979-4.96-4.469-7.408-8.632-7.408zM15.151 27.038H39.16a2.994 2.994 0 100-5.988H15.151a2.994 2.994 0 100 5.988zm8.324 10.342h7.354a2.995 2.995 0 000-5.989h-7.354a2.995 2.995 0 000 5.99zm10.303-26.673H20.527a2.994 2.994 0 100 5.988h13.251a2.994 2.994 0 100-5.988zm8.256-8.962l11.841 20.51a3.49 3.49 0 010 3.488l-11.841 20.51a3.489 3.489 0 01-3.022 1.744H15.331a3.489 3.489 0 01-3.022-1.744L.468 25.743a3.484 3.484 0 010-3.488l11.841-20.51A3.487 3.487 0 0115.331 0h23.681c1.247 0 2.4.665 3.022 1.745z"
                    fill="inherit"
                />
            </svg>
        </span>
    );

    if (isNew) {
        return logoElement;
    }

    // @TODO: find way to support @react-spring/web
    if (isAnimated) {
        return (
            // type for props should be reconsidered
            // React.CSSProperties?
            // @ts-ignore
            <LogoAnimation native={true}>
                {(animProps: any | undefined) => (
                    <animated.div style={{ ...animProps }}>{logoElement}</animated.div>
                )}
            </LogoAnimation>
        );
    }

    return logoElement;
}

export default Logo;
